import React, { useState } from "react";
import { AddModal } from "components";

const INITIAL_FORM_STATE = {
  article: "",
  price: "",
};

// Компонент додавання нового виключення сторінки "Виключення"
const ExclusionForm = ({ onAdd }) => {
  // Локальний стан для керування модальним вікном та даними форми
  const [isOpen, setIsOpen] = useState(false);
  const [formState, setFormState] = useState(INITIAL_FORM_STATE);

  // Універсальний обробник для полів вводу
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormState((prev) => ({ ...prev, [name]: value }));
  };

  // Функція закриття модального вікна
  const handleClose = () => {
    setFormState(INITIAL_FORM_STATE);
    setIsOpen(false);
  };

  // Функція обробки відправлення форми
  const handleSubmit = (e) => {
    e.preventDefault();
    const { article, price } = formState;

    // Перевіряємо наявність артикулу і ціни
    if (!article || !price) return;

    // Викликаємо функцію додавання та закриваємо форму
    onAdd(article, price);
    handleClose();
  };

  return (
    <>
      <button
        className="toggle-form-button focus-button"
        onClick={() => setIsOpen(true)}
      >
        Додати виключення
      </button>

      <AddModal isOpen={isOpen} onClose={handleClose} title="Додати виключення">
        <form onSubmit={handleSubmit}>
          <div className="add-modal-body">
            <div className="form-group">
              <label>Артикул *</label>
              <input
                name="article"
                type="text"
                placeholder="Введіть артикул"
                value={formState.article}
                onChange={handleChange}
                required
              />
            </div>

            <div className="form-group">
              <label>Ціна *</label>
              <input
                name="price"
                type="number"
                placeholder="Введіть ціну"
                value={formState.price}
                onChange={handleChange}
                required
              />
            </div>
          </div>

          <div className="add-modal-footer">
            <button type="button" className="btn-cancel" onClick={handleClose}>
              Відміна
            </button>
            <button type="submit" className="btn-save">
              Додати
            </button>
          </div>
        </form>
      </AddModal>
    </>
  );
};

export default ExclusionForm;
